import { useEffect } from "react";
import { useSelector } from "react-redux";
import { isUserAuthenticated } from "../selectors/user";

type UserAuthChangeParams = {
  loginAction?: () => void;
  logoutAction?: () => void;
};
export const useUserAuthChange = ({
  loginAction,
  logoutAction,
}: UserAuthChangeParams): void => {
  const isUserLoggedIn = useSelector(isUserAuthenticated);
  useEffect(() => {
    if (isUserLoggedIn && loginAction) {
      loginAction();
    }
    if (!isUserLoggedIn && logoutAction) {
      logoutAction();
    }
  }, [isUserLoggedIn, loginAction, logoutAction]);
};
